var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose24PxRoundedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/close_24px",
    d: "M18.2997 5.71069C18.1129 5.52344 17.8592 5.4182 17.5947 5.4182C17.3302 5.4182 17.0766 5.52344 16.8897 5.71069L11.9997 10.5907L7.10973 5.70069C6.9229 5.51344 6.66924 5.4082 6.40473 5.4082C6.14021 5.4082 5.88656 5.51344 5.69973 5.70069C5.30973 6.09069 5.30973 6.72069 5.69973 7.11069L10.5897 12.0007L5.69973 16.8907C5.30973 17.2807 5.30973 17.9107 5.69973 18.3007C6.08973 18.6907 6.71973 18.6907 7.10973 18.3007L11.9997 13.4107L16.8897 18.3007C17.2797 18.6907 17.9097 18.6907 18.2997 18.3007C18.6897 17.9107 18.6897 17.2807 18.2997 16.8907L13.4097 12.0007L18.2997 7.11069C18.6797 6.73069 18.6797 6.09069 18.2997 5.71069Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose24PxRoundedLight);
export default __webpack_public_path__ + "static/media/close_24px_rounded_light.fd73c78d.svg";
export { ForwardRef as ReactComponent };